import { useApiQuery } from '../useApiQuery'

export const useGetComplaints = (options = {}) => {
  const query = useApiQuery(
    ['complaints'],
    'schools',
    '/current-organization/complaints?include=complaintEntries',
    options,
    { authenticated: true, version: 4 }
  )

  return {
    complaints: Array.isArray(query.data) ? query.data : [],
    isLoading: query.isLoading || query.isFetching,
    error: query.error,
    mutate: query.refetch
  }
}
